import React from 'react';

import ProjectCreativeSnapshot from '../../../../components/project/project-creative-snapshot';
import ProjectPrintAds from '../../../../components/project/project-print-ads';
import ProjectBrandedMaterials from '../../../../components/project/project-branded-materials';
import ProjectSliderAnimation from '../../../../components/project/project-slider/project-slider-animation';
import ProjectMarketingTiles from '../../../../components/project/project-marketing-tiles';

const RicohCaseStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectCreativeSnapshot
        image={acf.creative_snapshot_image}
        blurb={acf.creative_snapshot_blurb}
        wrapperPadding={'0'}
      />
      <ProjectMarketingTiles
        images={acf.marketing_tiles}
        blurb={acf.marketing_tiles_blurb}
        wrapperPadding={'10vw 0 0 0'}
      />
      <ProjectBrandedMaterials
        image={acf.branded_materials_image}
        blurb={acf.branded_materials_blurb}
        wrapperPadding={'10vw 0 10vw 0'}
      />
      <ProjectPrintAds
        images={acf.print_ad_images}
        blurb={acf.print_ad_blurb}
        wrapperPadding={'0'}
      />
      <ProjectSliderAnimation
        slides={acf.slider}
        blurb={acf.slider_blurb}
        wrapperPadding={['10vw', '10vw 0']}
      />
    </React.Fragment>
  );
};

export default RicohCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/ricoh/index.js